import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BootstrapModal from 'react-bootstrap/Modal';

import './styles.css';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.hideModalOnEscKey = this.hideModalOnEscKey.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.hideModalOnEscKey);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.hideModalOnEscKey);
  }

  hideModalOnEscKey(event) {
    if (event.keyCode === 27 && this.props.show) {
      this.props.onHide();
    }
  }

  render() {
    const { children, show, onHide, title } = this.props;

    return (
      <BootstrapModal
        onHide={onHide}
        show={show}
        size="lg"
        aria-labelledby="modal-title-lg"
      >
        <BootstrapModal.Header className="has-border" closeButton>
          <BootstrapModal.Title id="modal-title-lg">
            {title}
          </BootstrapModal.Title>
        </BootstrapModal.Header>
        <BootstrapModal.Body>{children}</BootstrapModal.Body>
      </BootstrapModal>
    );
  }
}

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool
};

Modal.defaultProps = {
  show: false
};

export default Modal;
